import { render } from "./Home.vue?vue&type=template&id=61ad16fa&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "@/css/new-index.css?vue&type=style&index=0&id=61ad16fa&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ad16fa"]])

export default __exports__